import { render, staticRenderFns } from "./ProductUnit.vue?vue&type=template&id=46375941&"
import script from "./ProductUnit.vue?vue&type=script&lang=js&"
export * from "./ProductUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46375941')) {
      api.createRecord('46375941', component.options)
    } else {
      api.reload('46375941', component.options)
    }
    module.hot.accept("./ProductUnit.vue?vue&type=template&id=46375941&", function () {
      api.rerender('46375941', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/product-unit/ProductUnit.vue"
export default component.exports